import { Analytics } from "@/shared/utils/analytics/analytics";
import { useCookieStorage } from "@sazka/utils/use-storage";

let element: HTMLElement;

/**
 * Sets cookie, which means, notification shouldnt be showed to user again
 */
const setHidingCookie = (isPermanent: boolean) => {
    const storage = useCookieStorage();
    storage.setItem(
        `notification-${element.dataset.id}`,
        "hide",
        "essential",
        isPermanent
            ? {
                  expires: Date.now() + 365 * 24 * 60 * 60 * 1000,
              }
            : undefined
    );
};

const hide = () => {
    document.body.classList.remove("has-notification");

    element.classList.remove("active");
    element.classList.add("hiding");

    setTimeout(() => {
        element.style.display = "none";
    }, 300);
};

const init = () => {
    // set hiding cookie, if notification is one-timer
    if (element.dataset.time === "seating-time") {
        setHidingCookie(false);
    }

    element.querySelector(".sazka-notification__close")?.addEventListener("click", () => {
        const closePermanently = element.dataset.time === "close-time";
        setHidingCookie(closePermanently);
        hide();
        Analytics.actionShowPromo(
            `${element.dataset.analyticsName}.close`,
            element.dataset.analyticsName,
            element.dataset.analyticsVersion,
            "top-popup"
        );
    });

    element.querySelectorAll("a").forEach((a) => {
        a.addEventListener("click", () => {
            Analytics.actionShowPromo(
                element.dataset.analyticsName,
                element.dataset.analyticsName,
                element.dataset.analyticsVersion,
                "top-popup"
            );
        });
    });

    Analytics.addPromo(
        element.dataset.analyticsName,
        element.dataset.analyticsName,
        element.dataset.analyticsVersion,
        "top-popup"
    );
};

export const useNotifications = () => {
    if (environment.isEditMode) return;

    element = document.querySelector(".sazka-notification");
    if (!element) {
        return;
    }
    init();
};
